import React from "react"
import { Form, Select, Tooltip, Switch } from "antd"
import InputField from "../Common/InputField"
import {
  InfoCircleOutlined,
  LinkOutlined,
  UploadOutlined,
} from "@ant-design/icons"
import CustomUpload from "../Common/Uploadfile"
import UploadInput from "../Common/UploadInputfile"
import { COUNTRIES } from "../../utils/constants"
import { translations } from "../../utils/Translation/staticTranslation"

const StoreFormFields = ({
  form,
  mode,
  storeName,
  setStoreName,
  storeNameArabic,
  setStoreNameArabic,
  activeStore,
  setActiveStore,
}) => {
  const lang = localStorage.getItem("language") || "ar"
  const createStore = translations[lang]?.StorePage?.createStore
  const storeOptions = translations[lang]?.StorePage?.platformOptions
  return (
    <>
      <h3 className="text-141414 text-16 font-700 mb-28">
        {createStore?.general_details}
      </h3>
      {/* <div className="row mb-30">
        <InputField
          disabled={mode === "Update" || mode === "View"}
          label={createStore?.store_name}
          className="store-field store-form-placeholder "
          formclass="col-5 mb-0-imp"
          name="store_name"
          type="storeName"
          placeholder={createStore?.store_name_placeholder}
          rules={[{ required: true, message: createStore.store_name_rule_1 }]}
        />
        {console.log("createStore?.store_type-->>", createStore?.store_type)}
        <Form.Item
          className="col-5 error-input-fix"
          label={<span>{createStore?.store_type}</span>}
          name="store_type"
          rules={[
            {
              required: true,
              message: createStore?.store_type_error,
            },
          ]}
        >
          <Select
            disabled={mode === "Update" || mode === "View"}
            showSearch
            optionFilterProp="label"
            placeholder={createStore?.store_type_placeholder}
            className="store-select"
            options={[
              {
                value: "ZID",
                label: storeOptions?.ZID,
              },
              { value: "SALLA", label: storeOptions?.SALLA },
              {
                value: "MAGENTO",
                label: storeOptions?.MAGENTO,
              },
              {
                value: "SHOPIFY",
                label: storeOptions?.SHOPIFY,
              },
              { value: "OTHER", label: storeOptions?.Other },
            ]}
          />
        </Form.Item>
      </div> */}

      {/* Preview box Preferred Store name */}

      <div className="preview-box">
        <div className="d-flex">
          {/* Input Section */}
          <div
            className={`${lang === "ar" ? "ml-92" : "mr-92"}`}
            style={{ width: "50%" }}
          >
            {/* English Name */}
            <InputField
              disabled={mode === "Update" || mode === "View"}
              label={createStore?.store_name}
              className="store-field store-form-placeholder"
              formclass="mb-14"
              name="store_name"
              type="storeName"
              onChange={(e) => setStoreName(e.target.value)}
              placeholder={createStore?.store_name_placeholder}
              rules={[
                { required: true, message: createStore.store_name_rule_1 },
              ]}
              suffix={
                <Tooltip title={createStore?.preferred_name_tooltip}>
                  <InfoCircleOutlined />
                </Tooltip>
              }
            />

            {/* Arabic Name */}
            <InputField
              disabled={mode === "View"}
              label={createStore?.store_arabic_name || "الاسم التجاري بالعربية"}
              className="store-field store-form-placeholder"
              formclass="mb-14"
              name="store_name_arabic"
              type="storeArabicName"
              style={{ direction: "rtl", textAlign: "right" }}
              onChange={(e) => setStoreNameArabic(e.target.value)}
              placeholder={
                createStore?.store_arabic_name_placeholder ||
                "أدخل الاسم التجاري المسجل لمتجرك باللغة العربية"
              }
              rules={[
                {
                  required: true,
                  message: createStore?.preferred_name_error,
                },
              ]}
              suffix={
                <Tooltip title={createStore?.preferred_name_tooltip}>
                  <InfoCircleOutlined />
                </Tooltip>
              }
            />
          </div>

          {/* Preview Section */}
          <div className="preview-details" style={{ width: "50%" }}>
            <p className="text-14 text-141414 font-500 mb-24">
              {createStore?.preferred_name_preview}
            </p>
            <div className="d-flex">
              <div
                className={`text-center ${lang === "ar" ? "ml-20" : "mr-20"}`}
              >
                <img
                  src="/store/PreviewImage.png"
                  alt=""
                  width={147}
                  height={123}
                />
              </div>
              <div>
                {/* English */}
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                  }}
                >
                  {" "}
                  <p className="text-16 text-141414">
                    {storeName || createStore?.company_name}
                  </p>
                  {/* Arabic */}
                  <p
                    className="text-16 text-141414"
                    style={{ direction: "rtl", fontWeight: 500 }}
                  >
                    {storeNameArabic || "الاسم التجاري"}
                  </p>
                </div>

                <p className="text-14 text-3F3F3F mb-12">
                  Christina White Terrazzo Outdoor Stool Roots Furniture Miden
                  Home OS-239-W maiden home
                </p>

                <span className="text-14 text-141414 font-500">S45HFH56</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="row mb-30">
        {/* {console.log("createStore?.store_type-->>", createStore?.store_type)} */}
        <Form.Item
          className="col-12 error-input-fix"
          label={<span>{createStore?.store_type}</span>}
          name="store_type"
          rules={[
            {
              required: true,
              message: createStore?.store_type_error,
            },
          ]}
        >
          <Select
            disabled={mode === "Update" || mode === "View"}
            showSearch
            optionFilterProp="label"
            placeholder={createStore?.store_type_placeholder}
            className="store-select"
            options={[
              {
                value: "ZID",
                label: storeOptions?.ZID,
              },
              { value: "SALLA", label: storeOptions?.SALLA },
              {
                value: "MAGENTO",
                label: storeOptions?.MAGENTO,
              },
              {
                value: "SHOPIFY",
                label: storeOptions?.SHOPIFY,
              },
              { value: "OTHER", label: storeOptions?.Other },
            ]}
          />
        </Form.Item>
      </div>

      <div className="mb-20">
        <InputField
          disabled={mode === "View"}
          label={createStore?.store_description}
          formclass="mb-0-imp"
          type="textarea"
          className="store-field store-form-placeholder "
          name="store_description"
          placeholder={createStore?.store_description_placeholder}
          rows={3}
          rules={[
            { required: true, message: createStore?.store_description_error },
          ]}
        />
      </div>
      <div>
        <Form.Item
          disabled={mode === "View"}
          className=""
          label={createStore?.store_logo}
          name="logo"
          rules={[{ required: true, message: createStore?.store_logo_error }]}
        >
          <CustomUpload
            name="logo"
            form={form}
            onChange={(file) => form.setFieldsValue({ logo: file })}
            acceptedFormats={[".png", ".jpg", ".jpeg"]}
            maxSizeMB={1}
            bulkUpload={false}
            uploadText={createStore?.check_size}
          />
        </Form.Item>
      </div>

      {/* Business Details */}
      {/* Business Details */}
      <div className="my-28">
        <h3 className="text-141414 text-16 font-700 mb-28">
          {createStore?.business_details}
        </h3>
        <div className="row mb-20">
          <InputField
            disabled={mode === "Update" || mode === "View"}
            label={createStore?.registration_number}
            className="store-field store-form-placeholder "
            formclass="col-6 mb-0-imp "
            name="registration_number"
            type="storeName"
            placeholder={createStore?.registration_number_placeholder}
            rules={[
              {
                required: true,
                message: createStore?.registration_number_error,
              },
            ]}
            suffix={
              <Tooltip title={createStore?.registration_number_tooltip}>
                <InfoCircleOutlined />
              </Tooltip>
            }
          />
          <UploadInput
            disabled={mode === "Update" || mode === "View"}
            maxSizeMB={1}
            label={createStore?.certificate}
            className="store-field store-form-placeholder "
            formclass="col-6 mb-0-imp "
            name="registration_certificate"
            placeholder={createStore?.certificate_placeholder}
            rules={[
              {
                required: true,
                message: createStore?.certificate_error,
              },
            ]}
            suffix={
              <>
                <UploadOutlined />
                <Tooltip title={createStore?.certificate_tooltip}>
                  <InfoCircleOutlined />
                </Tooltip>
              </>
            }
          />
        </div>

        <div className="row mb-20">
          <InputField
            disabled={mode === "Update" || mode === "View"}
            label={createStore?.tax_number}
            className="store-field store-form-placeholder "
            formclass="col-6 mb-0-imp "
            name="vat_number"
            placeholder={createStore?.tax_number_placeholder}
            rules={
              [
                // {
                //   required: true,
                //   message: createStore?.tax_number_error,
                // },
              ]
            }
            suffix={
              <Tooltip title={createStore?.tax_number_tooltip}>
                <InfoCircleOutlined />
              </Tooltip>
            }
          />

          <UploadInput
            disabled={mode === "Update" || mode === "View"}
            maxSizeMB={1}
            label={createStore?.vat_certificate}
            className="store-field store-form-placeholder "
            formclass="col-6 mb-0-imp "
            name="vat_certificate"
            placeholder={createStore?.vat_certificate_placeholder}
            // rules={
            //   mode !== "Create"
            //     ? [
            //         {
            //           required: true,
            //           message: createStore?.vat_certificate_error,
            //         },
            //       ]
            //     : []
            // }
            suffix={
              <>
                <UploadOutlined />
                <Tooltip title={createStore?.vat_tooltip}>
                  <InfoCircleOutlined />
                </Tooltip>
              </>
            }
          />
        </div>

        <div className="row mb-20">
          <InputField
            disabled={mode === "Update" || mode === "View"}
            label={createStore?.business_url}
            className="store-field store-form-placeholder "
            formclass="col-6 mb-0-imp "
            name="business_url"
            placeholder={createStore?.business_url_placeholder}
            rules={[
              {
                required: true,
                message: createStore?.business_url_error,
              },
            ]}
            suffix={
              <Tooltip title={createStore?.business_url_tooltip}>
                <LinkOutlined />
              </Tooltip>
            }
          />
          <InputField
            disabled={mode === "Update" || mode === "View"}
            label={createStore?.maroof_link}
            className="store-field store-form-placeholder "
            formclass="col-6 mb-0-imp "
            name="maroof_link"
            placeholder={createStore?.maroof_link_placeholder}
            rules={[
              {
                type: "url",
                message: createStore?.location_error_2,
              },
              // {
              //   required: true,
              //   message: createStore?.maroof_link_error,
              // },
            ]}
            suffix={
              <>
                <LinkOutlined />
                <Tooltip title={createStore?.maroof_link_tooltip}>
                  <InfoCircleOutlined />
                </Tooltip>
              </>
            }
          />
        </div>

        <div className="row mb-20">
          <InputField
            disabled={mode === "View"}
            label={createStore?.location}
            className="store-field store-form-placeholder "
            formclass="col-6 mb-0-imp "
            name="location"
            placeholder={createStore?.location_placeholder}
            rules={[
              {
                type: "url",
                message: createStore?.location_error_2,
              },
              {
                required: true,
                message: createStore?.location_error_1,
              },
            ]}
            suffix={
              <>
                <LinkOutlined />{" "}
                <Tooltip title={createStore?.location_tooltip}>
                  <InfoCircleOutlined />
                </Tooltip>
              </>
            }
          />

          <Form.Item
            disabled={mode === "View"}
            className="col-6 mb-0-imp"
            label={createStore?.country_of_sale}
            name="countries"
            rules={[
              {
                required: true,
                message: createStore?.country_of_sale_error,
              },
            ]}
          >
            <Select
              mode="multiple"
              maxTagCount="responsive"
              optionFilterProp="label"
              placeholder={createStore?.country_of_sale_placeholder}
              className="country-select"
              options={COUNTRIES.map((country) => ({
                value: country.value,
                label: lang === "ar" ? country.label_ar : country.label_en,
              }))}
              suffixIcon={
                <>
                  <Tooltip title={createStore?.country_of_sale_tooltip}>
                    <InfoCircleOutlined />
                  </Tooltip>
                </>
              }
            />
          </Form.Item>
        </div>
      </div>

      {/* Store Status Toggle (only for Update mode) */}
      {mode === "Update" && (
        <div className="store-status-section">
          <div className="d-flex">
            <div className="status-toggle">
              {setActiveStore && (
                <div className="d-flex">
                  <p className="mb-0 text-141414 text-14 mr-10">
                    {createStore?.store_status}
                  </p>
                  <Switch
                    className="custom-switch"
                    checked={activeStore}
                    onChange={() => setActiveStore(!activeStore)}
                  />
                </div>
              )}
              <div>
                {" "}
                <span className="text-7A7A7A text-13 font-400">
                  {createStore?.store_status}
                </span>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  )
}

export default StoreFormFields
